/**
 * Element width with all padding, borders and margins
 *
 * @param element
 */
const elementOuterWidth = (element: HTMLElement) => {
    const style = (element as any).currentStyle || window.getComputedStyle(element),
        width = element.offsetWidth, // or use style.width
        margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight),
        padding = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight),
        border = parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);

    return width + margin - padding + border;
}

/**
 * changes favicon for page
 * @param url link for favicon image
 */
const changeFavicon = (url: string) => {
    let link = document.querySelector("link[rel*='icon']") as HTMLLinkElement | undefined || document.createElement('link') as HTMLLinkElement;
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = url;
    document.getElementsByTagName('head')[0].appendChild(link);
}

const hasHorizontalScroll = (element: HTMLElement) => {
    return element.scrollWidth > element.clientWidth;
}

const hasVerticalScroll = (element: HTMLElement) => {
    return element.scrollHeight > element.clientHeight;
}

const hasAnyScrolls = (element: HTMLElement) => {
    return hasHorizontalScroll(element) || hasVerticalScroll(element);
}

export { elementOuterWidth, changeFavicon, hasAnyScrolls }
